export const TEXTS_MOVILIDAD = {
  es_ES: new Map([
    ['chartNameAccesoCiudad', 'ACCESOS A LA CIUDAD'],
    ['chartNameViasPrincipales', 'VÍAS PRINCIPALES DE LA CIUDAD'],
    ['IntensidadUnidad', 'vehículos'],
    ['chartNameAcumulado', 'ACUMULADO'],
    ['chartNameUsuariosMesActual', 'MES ACTUAL'],
    ['chartNameUsuariosMesAnterior', 'MES ANTERIOR'],
    ['chartNameUsuariosUltimosAnyos', 'ULTIMOS AÑOS'],
    ['chartNameUsuarisTotals', 'USO DE EMT: TRAYECTOS TOTALES'],
    ['UnidadMedida', 'Trayectos'],
    ['UsuarisTotalsValor', 'Número trayectos EMT'],
    ['reset', 'Restablecer'],
    ['download', 'Descargar'],
  ]),
  ca_ES: new Map([
    ['chartNameAccesoCiudad', 'ACCESSOS A LA CIUTAT'],
    ['chartNameViasPrincipales', 'VIES PRINCIPALS DE LA CIUTAT'],
    ['IntensidadUnidad', 'vehicles'],
    ['chartNameAcumulado', 'ACUMULAT'],
    ['chartNameUsuariosMesActual', 'MES ACTUAL'],
    ['chartNameUsuariosMesAnterior', 'MES ANTERIOR'],
    ['chartNameUsuariosUltimosAnyos', 'ÚLTIMS ANYS'],
    ['chartNameUsuarisTotals', "ÚS D'EMT: TRAJECTES TOTALS"],
    ['UnidadMedida', 'Trajectes'],
    ['UsuarisTotalsValor', 'Nombre trajectes EMT'],
    ['reset', 'Restablir'],
    ['download', 'Desar'],
  ]),
};
